import { render, staticRenderFns } from "./NoExiste.vue?vue&type=template&id=24d06c2c&scoped=true"
var script = {}
import style0 from "./NoExiste.vue?vue&type=style&index=0&id=24d06c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d06c2c",
  null
  
)

export default component.exports